import { z } from "zod";

//#region src/lib/moderation/enums.ts
/**
* Detector codes the classifier may attach to a verdict. Fixed in code because
* they are part of the model's structured-output schema; which codes count as
* fraud vs policy is configurable.
*/
const MODERATION_SIGNALS = [
	"platform_impersonation",
	"account_restriction_claim",
	"verification_request",
	"credential_request",
	"obfuscated_link",
	"payment_redirection",
	"off_platform_contact",
	"urgency_pressure",
	"prize_or_refund_bait",
	"threats_or_harassment"
];
const ModerationSignalSchema = z.enum(MODERATION_SIGNALS);
const MODERATION_SURFACES = [
	"offer_message",
	"counter_message",
	"chat_message"
];
const ModerationSurfaceSchema = z.enum(MODERATION_SURFACES);
const MODERATION_VERDICTS = [
	"clean",
	"suspicious",
	"scam"
];
const ModerationVerdictSchema = z.enum(MODERATION_VERDICTS);
/** What the screening path did with the message once the verdict came back. */
const MODERATION_ACTIONS = [
	"delivered",
	"stripped",
	"rejected",
	"flagged",
	"suspended"
];
const ModerationActionSchema = z.enum(MODERATION_ACTIONS);
const MODERATION_REVIEW_OUTCOMES = ["false_positive", "confirmed"];
const ModerationReviewOutcomeSchema = z.enum(MODERATION_REVIEW_OUTCOMES);
const MODERATION_SEVERITIES = [
	"low",
	"medium",
	"high",
	"critical"
];
const ModerationSeveritySchema = z.enum(MODERATION_SEVERITIES);
const MODERATION_CASE_STATUSES = [
	"open",
	"reviewing",
	"resolved"
];
const ModerationCaseStatusSchema = z.enum(MODERATION_CASE_STATUSES);
const MODERATION_CASE_RESOLUTIONS = [
	"dismissed",
	"warned",
	"suspended",
	"purged",
	"cleared"
];
const ModerationCaseResolutionSchema = z.enum(MODERATION_CASE_RESOLUTIONS);
/** Automatic steps the pipeline took on a case. */
const MODERATION_AUTO_ACTIONS = [
	"auto_suspended",
	"notification_withheld",
	"warning_posted"
];
const ModerationAutoActionSchema = z.enum(MODERATION_AUTO_ACTIONS);
/** Why a scam verdict did not suspend the author automatically. */
const MODERATION_AUTO_ACTION_SKIPPED_REASONS = [
	"pro_seller",
	"trusted_transacted",
	"recently_cleared"
];
const ModerationAutoActionSkippedReasonSchema = z.enum(MODERATION_AUTO_ACTION_SKIPPED_REASONS);
const MODERATION_REASONING_EFFORTS = [
	"none",
	"minimal",
	"low",
	"medium",
	"high"
];
/** Policy categories a formal warning names to the user. */
const MODERATION_WARNING_REASONS = [
	"payment_redirection",
	"off_platform_contact",
	"other"
];
const ModerationWarningReasonSchema = z.enum(MODERATION_WARNING_REASONS);
/** What a piece of content taken down by moderation was, before it was removed. */
const MODERATION_REMOVED_SOURCES = ["chat_message", "offer_message"];
const ModerationRemovedSourceSchema = z.enum(MODERATION_REMOVED_SOURCES);

//#endregion
export { MODERATION_ACTIONS, MODERATION_AUTO_ACTIONS, MODERATION_AUTO_ACTION_SKIPPED_REASONS, MODERATION_CASE_RESOLUTIONS, MODERATION_CASE_STATUSES, MODERATION_REASONING_EFFORTS, MODERATION_REMOVED_SOURCES, MODERATION_REVIEW_OUTCOMES, MODERATION_SEVERITIES, MODERATION_SIGNALS, MODERATION_SURFACES, MODERATION_VERDICTS, MODERATION_WARNING_REASONS, ModerationActionSchema, ModerationAutoActionSchema, ModerationAutoActionSkippedReasonSchema, ModerationCaseResolutionSchema, ModerationCaseStatusSchema, ModerationRemovedSourceSchema, ModerationReviewOutcomeSchema, ModerationSeveritySchema, ModerationSignalSchema, ModerationSurfaceSchema, ModerationVerdictSchema, ModerationWarningReasonSchema };
//# sourceMappingURL=enums.js.map